import * as React from 'react';
import { ExpenditureTableChart } from '../../../interface/MyInterfaces';
import * as Helpers from '../../Common/Helpers';

export class ExpenditureTable extends React.Component<ExpenditureTableChart, {}> {
    render() {
        if (this.props.SpendingExpenditureTable !== undefined && this.props.SpendingExpenditureTable2 !== undefined) {
            var table1 = this.props.SpendingExpenditureTable;
            var table2 = this.props.SpendingExpenditureTable2;

            var the_rows = [];

            if (table1 !== undefined && table2 !== undefined) {
                the_rows.push(["In-state", table2.in_state_pct, table1.avg_in_state, table1.std_in_state, 0, Helpers.outlier(table1.avg_in_state, table1.std_in_state, table2.in_state_pct)]);
                the_rows.push(["$10,000+", table2.large_pct, table1.avg_large, table1.std_large, 1, Helpers.outlier(table1.avg_large, table1.std_large, table2.large_pct)]);
                the_rows.push(["$1,000-$9,999", table2.ten_thousand_pct, table1.avg_ten_thousand, table1.std_ten_thousand, 2, Helpers.outlier(table1.avg_ten_thousand, table1.std_ten_thousand, table2.ten_thousand_pct)]);
                the_rows.push(["$100-$999", table2.one_thousand_pct, table1.avg_thousand, table1.std_thousand, 3, Helpers.outlier(table1.avg_thousand, table1.std_thousand, table2.one_thousand_pct)]);
                the_rows.push(["$1-$99", table2.one_hundred_pct, table1.avg_hundred, table1.std_hundred, 4, Helpers.outlier(table1.avg_hundred, table1.std_hundred, table2.one_hundred_pct)]);
                the_rows.push(["< 0", table2.neg_pct, table1.avg_neg, table1.std_neg, 5, Helpers.outlier(table1.avg_neg, table1.std_neg, table2.neg_pct)]);
            }

            var expenditureList = the_rows.map((item) => {
                return <tr key={item[4]}>
                    <td className={"color" + item[5]}>{item[0]}</td>
                    <td className={"color" + item[5]}>{item[1]}%</td>
                    <td className={"color" + item[5]}>{item[2]} ± {item[3]}</td>
                </tr>
            });

            return <table className="table expendituretable">
                <thead><tr><th>Range of dollars in Transaction</th><th>Percentage</th><th>Mean	± Std</th></tr></thead>
                <tbody>
                    {expenditureList}
                </tbody>
            </table>
        }
        return <div>Loading...</div>
    }
}